import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { GUEST_TYPES } from '../constants';

@Directive({
	selector: '[showLicense]',
})
export class ShowLicenseDirective implements OnChanges, OnInit {
	@Input() showLicense: number = null;
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private elementRef: ElementRef) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	public ngOnInit() {
		this.onShowLicense();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnChanges
	 **-------------------------------------------------------------------------------------
	 */
	public ngOnChanges(changes: SimpleChanges): void {
		const { showLicense } = changes;
		if (showLicense?.currentValue !== null) {
			this.showLicense = showLicense.currentValue;
			this.onShowLicense();

		};
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - showLicense
	 **-------------------------------------------------------------------------------------
	 */
	public onShowLicense(): void {
		if ([GUEST_TYPES.operator, GUEST_TYPES.primaryOperator,GUEST_TYPES.additionalOperator].includes(this.showLicense)) {
			this.elementRef.nativeElement.style.display = 'block';
			return;
		}
		this.elementRef.nativeElement.style.display = 'none';
	}
}
